<div class="blocked-page" fxLayout="column" fxLayoutAlign="center center">
  <mat-icon svgIcon="lock_outline"></mat-icon>
  <div class="title">{{ 'MAIN.BLOCKED_PAGE_TITLE' | translate }}</div>
  <div class="message-title">{{ 'MAIN.REASON' | translate }}: {{ message }}</div>
  <div class="message-title">{{ 'MAIN.BLOCKED_PAGE_DESCRIPTION' | translate }}</div>
</div>
